<div class="edit-account-root">
  <app-image-upload icon="person"
                  id="edit-account-image-upload"
                  [fileUploadLabel]="[labels.uploadImage, labels.changeImage]"
                  [fileUploadAlt]="[labels.uploadImageAlt,labels.uploadedImageAlt]"
                  [abstractControl]="profilePictureFormControl">
  </app-image-upload>
  <app-header>{{labels.personalData}}</app-header>
  <form>
    <div class="name-grid">
      <app-input id="edit-account-first-name-input"
              [label]="labels.name"
              [control]="nameFormControl"
              value="representativeData?.firstName"
              required>
      </app-input>
      <app-input id="edit-account-last-name-input"
            [label]="labels.lastName"
            [control]="lastNameFormControl"
            required>
      </app-input>
    </div>
    <app-input id="edit-account-email-input"
          [label]="labels.emailAddress"
          [control]="emailFormControl"
          disabled
          required>
    </app-input>
  </form>
  <app-header class="password-header">
    {{labels.password}}
  </app-header>
  <app-anchor id="change-password-click"
              class="change-password-click"
              [routerLink]="'/'+RoutesKeys.CHANGE_PASSWORD">
    {{labels.clickHereChangePassword}}
  </app-anchor>
  <div class="delete-account">
    <app-header class="delete-your-account-header">
      {{deleteAccountHeader()}}
    </app-header>
    <div *ngIf="!canDisableAcc" class="cant-disable">
      {{labels.deleteAccountUnableText}}
    </div>
    <app-anchor *ngIf="!isDeleteAccountRequestPending && canDisableAcc"
                id="delete-your-account-click"
                class="delete-your-account-click"
                [routerLink]="'/'+RoutesKeys.DELETE_ACCOUNT">
      {{labels.clickHereDeleteAccount}}
    </app-anchor>
  </div>
  <div *ngIf="isDeleteAccountRequestPending" class="delete-account-request">
    <span class="delete-account-label" isBig>{{labels.deleteAccountRequest}}</span>
    <div class="delete-account-request-status" title="{{labels.deleteAccountRequestStatus}}">
        <span class="label-small">{{ labels.pending }}</span>
        <div class="icon" title="{{labels.pending}}">
          <app-circle id="delete-account-request-status" size="xsmall" filled innerShadow>schedule</app-circle>
        </div>
    </div>
  </div>
  <app-primary-button id="save-account-changes-click" [disabled]="isFormDisabled() || loading" (clickAction)="saveAccountChanges()">
    {{labels.saveAccountChanges}}
  </app-primary-button>
</div>
